// extracted by mini-css-extract-plugin
module.exports =  {"postLimit":"mm4AkDmv","message":"FGs26lpN","button":"VQXPZbL0","action":"ox0p4JLK","middot":"lkkWzbRn"};